// The plans on the website's pricing section. A plan button sends the
// visitor to /welcome?plan=<id>; signed-out visitors sign up first (the
// sign-in page reads the plan from the saved destination and asks for their
// name), then land on the welcome page, which records the plan for the
// operator and offers the next step.

export type PlanId = "eb1a" | "eb1a_niw" | "attorney" | "o1a";

export const PLANS: Record<PlanId, { name: string; price: string; terms: string; waitlist?: boolean; founder?: boolean }> = {
  eb1a: {
    name: "EB-1A",
    price: "$5,000",
    terms: "Everything to prepare your EB-1A petition, start to finish.",
  },
  eb1a_niw: {
    name: "EB-1A + EB-2 NIW",
    price: "$8,500",
    terms: "Both petitions: $5,000 for the EB-1A and $3,500 for the EB-2 NIW.",
  },
  attorney: {
    name: "EB-1A with an attorney",
    price: "$9,000",
    terms: "Coming soon. Join the waitlist and we'll email you when it opens.",
    waitlist: true,
  },
  // The founder track: the founder signs the services agreement in the app
  // (/o1a/review), with the same fees as the EB-1A agreements. Founder
  // screens say "work visa" and "green card", not the visa names.
  o1a: {
    name: "Founder plan",
    price: "$5,000 or $8,500",
    terms:
      "A work visa or a green card is $5,000; both is $8,500, with the second $3,500 only if you go ahead with the green card. It's all in your agreement, and nothing is charged before you sign.",
    founder: true,
  },
};

/** The plan named in a URL or saved destination (e.g. "/welcome?plan=eb1a"). */
export function planFrom(target: string | null | undefined): PlanId | null {
  const m = /[?&]plan=([a-z0-9_]+)/.exec(target || "");
  const id = m?.[1];
  return id && id in PLANS ? (id as PlanId) : null;
}

/** The free 2-minute case check built by the Assessment page, which names the bundle "bundle". */
export function assessmentUrl(plan: PlanId): string {
  return plan === "attorney" ? "/assessment" : `/assessment?plan=${plan === "eb1a_niw" ? "bundle" : plan}`;
}

/** Current USCIS filing fees; we link here instead of quoting amounts that change. */
export const FEE_CALCULATOR_URL = "https://www.uscis.gov/feecalculator";

/** The free 30-minute consultation; also used for the kickoff call. */
export const KICKOFF_CALL_URL = "https://calendly.com/visagenius/visagenius-green-card-consultation";

/** The name typed on the sign-up page, handed to the welcome page. */
export const SIGNUP_NAME_KEY = "vg-signup-name";
